/**
 * Session / token helpers for deep-link handoff from Admin (Phase 3 expands this).
 */

const TOKEN_KEY = 'p1vp12.token'

export function readLaunchContext () {
  const q = new URLSearchParams(window.location.search || '')
  return {
    projectId: q.get('projectId') || q.get('ProjectID') || '',
    folderId: q.get('folderId') || q.get('FolderID') || '',
    viewAs: (q.get('viewAs') || 'vendor').toLowerCase() === 'team' ? 'team' : 'vendor',
    token: q.get('token') || q.get('access_token') || ''
  }
}

export function getStoredToken () {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function setStoredToken (token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch (e) {}
}

export function applyLaunchAuth (ctx) {
  if (ctx && ctx.token) {
    setStoredToken(ctx.token)
    try {
      sessionStorage.setItem('user_token', ctx.token)
    } catch (e) {}
  }
}
